(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.localesReady) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-locale-tab]'));
    var media = Array.prototype.slice.call(root.querySelectorAll('[data-locale-media]'));
    var addressEl = root.querySelector('[data-locale-address]');
    var addressBag = root.querySelector('[data-locale-addresses]');
    var addresses = addressBag
      ? (addressBag.getAttribute('data-locale-addresses') || '').split('|')
      : [];
    if (!tabs.length) return;

    root.dataset.localesReady = '1';

    function select(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        // Roving tabindex: only the selected city is a tab stop, so the
        // group is one stop in the page order rather than three.
        tab.tabIndex = on ? 0 : -1;
      });
      media.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      // one address line, rewritten rather than three stacked
      if (addressEl && addresses[index] !== undefined) {
        addressEl.textContent = addresses[index];
      }
      if (moveFocus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });

      tab.addEventListener('keydown', function (e) {
        var last = tabs.length - 1;
        var next = null;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;

        if (next !== null) {
          e.preventDefault();
          select(next, true);
        }
      });
    });

    // Whatever the markup shipped as active stays active — no reset on load.
    var start = tabs.findIndex(function (t) { return t.classList.contains('is-active'); });
    select(start < 0 ? 0 : start, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-locales]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  } else {
    initAll();
  }

  // The theme editor tears a section down and rebuilds it on every change, so
  // the fresh markup needs wiring up again — the guard flag above lives on the
  // element and is discarded with it.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
